import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';

KTBSCard.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  icon: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  footer: PropTypes.element,
  toolbar: PropTypes.element,
  subToolbar: PropTypes.element,
  additionalClassName: PropTypes.string,
  additionalHeaderClassName: PropTypes.string,
  additionalFooterClassName: PropTypes.string,
  additionalBodyClassName: PropTypes.string,
  hideDividerHeader: PropTypes.bool,
  hideDividerFooter: PropTypes.bool,
  leftTitleEl: PropTypes.element,
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleClickIcon: PropTypes.func,
};

function KTBSCard({
  id = '',
  title = '',
  subTitle = '',
  icon = '',
  description = null,
  body = '',
  footer = null,
  toolbar = null,
  subToolbar = null,
  additionalClassName = '',
  additionalHeaderClassName = '',
  additionalFooterClassName = '',
  additionalBodyClassName = '',
  hideDividerHeader = false,
  hideDividerFooter = false,
  leftTitleEl,
  borderRadius = '0',
  handleClickIcon = () => {},
}) {
  return (
    <div
      className={`card card-custom ${additionalClassName}`}
      id={id}
      style={{
        border: '1px solid rgba(219, 223, 241, 1)',
        borderRadius: `${borderRadius}px`,
      }}
    >
      {/* header */}
      {title.length > 0 && (
        <div
          className={`card-header ${
            hideDividerHeader ? 'border-0' : ''
          } ${additionalHeaderClassName}`}
          style={{
            padding: `15px 15px 10px 15px`,
          }}
        >
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex flex-row align-items-start">
              {leftTitleEl && leftTitleEl}
              <div className="card-title">
                <h3 className="card-label">
                  {icon && (
                    <span
                      className={`mr-4 ${handleClickIcon ? 'cursor-pointer' : ''}`}
                      onClick={handleClickIcon}
                    >
                      <i className={`${icon} text-body`}></i>
                    </span>
                  )}
                  <span
                    className=""
                    style={{
                      fontWeight: '600',
                      fontSize: Utils.returnFontSize(18),
                      color: AppColors.gray[800],
                    }}
                  >
                    {title}
                  </span>
                  {!_.isEmpty(subTitle) && (
                    <small style={{ color: AppColors.gray[700] }}>{subTitle}</small>
                  )}
                  {description && (
                    <span
                      className={`mt-1 d-block ${icon ? 'pl-7' : ''}`}
                      style={{
                        color: AppColors.gray[700],
                        fontSize: Utils.returnFontSize(14),
                        fontWeight: '500',
                      }}
                    >
                      {description}
                    </span>
                  )}
                </h3>
              </div>
            </div>

            {/* toolbar */}
            {toolbar && <div className="card-toolbar">{toolbar}</div>}
          </div>

          {subToolbar && subToolbar}
        </div>
      )}

      {/* body */}
      <div
        className={`card-body ${additionalBodyClassName}`}
        style={{
          padding: `10px 13px 10px 13px`,
        }}
      >
        {body}
      </div>

      {/* footer */}
      {footer && (
        <div
          className={`card-footer ${
            hideDividerFooter ? 'border-0' : ''
          } ${additionalFooterClassName}`}
          style={{
            padding: `10px 13px 10px 13px`,
          }}
        >
          {footer}
        </div>
      )}
    </div>
  );
}

export default KTBSCard;
